module.exports = __webpack_public_path__ + "images/kihnu/routes/pointers/LAA-PII-LAA.png";